// 2026-10-07 · Dispositivo de cada fichaje.
//
// El API guarda en el fichaje el dispositivo que ficha: el `deviceId` del
// cuerpo o, si no llega, la cabecera SessionIdentifier. Solo mandamos el
// identificador REAL del dispositivo (el `sessionIdentifier` que ya usa
// axios y que está en la tabla Devices); el id anónimo de getDeviceId() no
// corresponde a ningún dispositivo, así que en ese caso no se envía.

export function clockingDeviceId() {
  try {
    const sid = window.localStorage.getItem("sessionIdentifier");
    return sid || undefined;
  } catch {
    return undefined;
  }
}

/** Texto del dispositivo de un fichaje: nombre, «Dispositivo sin nombre» o «—». */
export function clockingDeviceLabel(name, identifier) {
  if (name) return name;
  if (identifier) return "Dispositivo sin nombre";
  return "—";
}

/**
 * Cuerpo de POST /employeeShift con el dispositivo que ficha. Lo usan el
 * fichaje del empleado y el cierre de fichajes olvidados.
 */
export function buildShiftAction(fields) {
  return { ...fields, deviceId: clockingDeviceId() };
}
